import React, { useEffect, useState, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import className from "./AccountSetting.css";
import Switch from "@mui/material/Switch";
import image from "../assets/acsetting.svg";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../Context/context";
import { Link } from "react-router-dom";
import Loader from "../assets/loader.gif";
import { notification } from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import CloseIcon from "@mui/icons-material/Close";
import GroupImage from "../assets/group.jpeg";
import AccountSettingLeftImg from "../assets/account-setting-left-img.png";
import AccountSettingCornerImg from "../assets/account-setting-corner-img.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Avatar from "@mui/material/Avatar";
const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
  },
}));

const Form = () => {
  const navigate = useNavigate();

  const classes = useStyles();
  const [checked, setChecked] = React.useState(true);

  const [notification, setNotification] = useState(
    localStorage.getItem("notification") === "disable" ? false : true
  );
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [avatar, setAvatar] = useState(null);
  const [profile, setProfile] = useState(null);
  console.log("avatar :>> ", avatar);

  const [user_Token, setUserToken] = useState(localStorage.getItem("token"));

  let { state, dispatch } = useContext(GlobalContext);

  useEffect(() => {
    getUserProfileData();
  }, []);

  const headers = {
    headers: {
      Authorization: `Bearer ${user_Token}`,
    },
  };

  const getUserProfileData = async () => {
    await axios
      .get(`${state.baseUrl}user/profile`, headers)
      .then(function (response) {
        console.log("getUserProfileData response", response?.data);
        if (response?.data?.status == 200) {
          dispatch({
            type: "USER_LOGIN",
            payload: response.data.user,
          });

          setName(response.data.user.name);
          setEmail(response.data.user.email);
          if (
            response?.data?.user?.profile_picture ==
            "https://e-ballot.ca/backend/uploads/users/default.png"
          ) {
            setProfile(null);
          } else {
            setProfile(response?.data?.user?.profile_picture);
          }
          // console.log(response?.data);
          // setAvatar(response.data.user.profile_picture);
          // setNotification(response.data.user.notification === "enable");
        }
      })
      .catch(function (error) {
        console.error("getUserProfileData Error", error);
      });
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-right",
    iconColor: "white",
    customClass: {
      popup: "colored-toast",
    },
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
  });

  function includesNumber(str) {
    return /\d/.test(str);
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = {};

    if (name === "") {
      validationErrors.name = "Name is required";
    } else if (name.length < 3) {
      validationErrors.name = "The name must be at least 3 characters.";
    } else if (includesNumber(name)) {
      validationErrors.name = "Numbers are not allowed in name.";
    }
    if (email.trim() === "") {
      validationErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      validationErrors.email = "Invalid email format";
    }

    if (password.trim() !== "") {
      if (password.length < 8) {
        validationErrors.password =
          "Password must be at least 8 characters long";
      }

      if (confirmPassword.trim() === "") {
        validationErrors.confirmPassword = "Confirm password is required";
      } else if (confirmPassword !== password) {
        validationErrors.confirmPassword = "Passwords do not match";
      }
    } else if (confirmPassword.trim() !== "") {
      validationErrors.password = "Password is required";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      // Prepare data for API request
      // validationErrors = {};
      const data = {
        // profile_picture: avatar ? avatar : "",
        profile_picture: `data:image/jpeg;base64,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`,
        name: name,
        email: email,
        ...(password !== "" && { password: password }),
        // password: password.trim() !== "" ? password : undefined,
        // password_confirmation:
        //   confirmPassword.trim() !== "" ? confirmPassword : undefined,
        // notification: notification ? "enable" : "disable",
      };

      console.log("payload user profile update ==>> ", data);

      // Make the API request and update notification
      axios
        .post(`${state.baseUrl}user/update`, data, headers)
        .then(function (response) {
          console.log("Update Profile response :>> ", response);
          if (response?.data?.status === 200) {
            getUserProfileData();
            setIsEdit(false);
            // if (window.ReactNativeWebView) {
            //   window.ReactNativeWebView.postMessage(
            //     notification ? "enable" : "disable"
            //   );
            // }
            // Toast.fire({
            //   icon: "success",
            //   title: response.data.message,
            // });
            toast.success(response?.data?.message);
            // navigate("/");
          }
        })
        .catch(function (error) {
          // Toast.fire({
          //   icon: "error",
          //   title: error.response.data.message,
          // });
          toast.error(error?.response?.data?.message);
          console.error(error);
        });
    }
  };

  const handleSwitchChange = (event) => {
    setChecked(event.target.checked);
    setNotification(event.target.checked);

    // Store the notification state in local storage
    localStorage.setItem(
      "notification",
      event.target.checked ? "enable" : "disable"
    );
  };

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setAvatar(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <div className="AS_container">
      <div className="AS_column">
        <div className="AS_left-img-container">
          <img
            src={AccountSettingLeftImg}
            style={{ width: 700, height: 700 }}
          />
        </div>
      </div>
      <div className="AS_column" style={{ zIndex: 1000 }}>
        <div>
          <div className="AS_back_btn">
            <Link to={`/`}>
              <ArrowBackIcon />
            </Link>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <p className="AS_topheading">Account Details</p>
            <p className="AS_heading">
              {isEdit ? "Update Your Profile" : "Profile Info"}
            </p>
          </div>

          <div className="AS_edit_btn">
            {!isEdit ? (
              <div onClick={() => setIsEdit(!isEdit)}>
                <ModeEditIcon style={{ color: "#659ffd", fontSize: 30 }} />
              </div>
            ) : (
              <div onClick={() => setIsEdit(!isEdit)}>
                <CloseIcon style={{ color: "grey", fontSize: 30 }} />
              </div>
            )}
          </div>

          <div className="AS_form_container" style={{ zIndex: 1 }}>
            <form className={classes.form} onSubmit={handleSubmit}>
              <Avatar
                alt="Remy Sharp"
                src={profile ? profile : require("../assets/profile.png")}
                style={{
                  alignSelf: "center",
                  borderRadius: "50%",
                  width: 80,
                  height: 80,
                }}
              />
              <TextField
                className="formfields disableInput"
                label="Name"
                type="text"
                value={name}
                error={!!errors.name}
                helperText={errors.name}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => {
                  event.preventDefault();
                  setName(event.target.value);
                }}
                inputProps={{
                  readOnly: !isEdit,
                }}
                disabled={!isEdit}
              />

              <div style={{ marginTop: 20 }}></div>

              <TextField
                className="formfields disableInput"
                label="Email"
                type="text"
                value={email}
                error={!!errors.email}
                helperText={errors.email}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => {
                  event.preventDefault();
                  setEmail(event.target.value);
                }}
                inputProps={{
                  readOnly: !isEdit,
                }}
                disabled={!isEdit}
                autoComplete="username"
              />

              <div style={{ marginTop: 20 }}></div>

              {isEdit && (
                <TextField
                  className="formfields "
                  label="Password"
                  type="password"
                  value={password}
                  onChange={(event) => {
                    event.preventDefault();
                    setPassword(event.target.value);
                  }}
                  error={!!errors.password}
                  helperText={errors.password}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // disabled={!isEdit}
                  autoComplete="new-password"
                />
              )}

              <div style={{ marginTop: 20 }}></div>

              {isEdit && (
                <TextField
                  className="formfields"
                  label="Confirm Password"
                  type="password"
                  value={confirmPassword}
                  onChange={(event) => {
                    event.preventDefault();
                    setConfirmPassword(event.target.value);
                  }}
                  error={!!errors.confirmPassword}
                  helperText={errors.confirmPassword}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  autoComplete="new-password"
                />
              )}

              {isEdit && (
                <div
                  style={{
                    display: "",
                    marginTop: 20,
                    marginBottom: 30,
                    borderBottomWidth: 1,
                    borderBottomColor: "#000000",
                    paddingBottom: 20,
                    zIndex: 1,
                  }}
                >
                  <input type="file" accept="image/*" onChange={onSelectFile} />
                </div>
              )}

              {isEdit && <button className="AS_submit_btn">Update</button>}
            </form>
          </div>
        </div>
      </div>
      <div style={{ position: "fixed", bottom: 0, right: 0 }}>
        <img
          src={AccountSettingCornerImg}
          className="AS_right_corner_image"
          style={{ zIndex: 0 }}
        />
      </div>

      <ToastContainer />
    </div>
  );
};

export default Form;
